'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('base62');

var _base2 = _interopRequireDefault(_base);

var _padLeft = require('./padLeft');

var _padLeft2 = _interopRequireDefault(_padLeft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createPad = function createPad(length) {
    return new Array(length).join('0');
};

exports.default = function (length) {
    var randomVal = Math.floor(Math.random() * Math.pow(62, length));
    return (0, _padLeft2.default)(_base2.default.encode(randomVal), createPad(length));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/uid/randomString.js
// module id = 2288
// module chunks = 0